import httpClient from "../../configs/http-client";
import apiUrl from "../../constants/apiUrl";
import { IPhoneRegistration } from "./auth.interface";

export const postRegistration = async ({
                                         prefix = "",
                                         phoneNumber = "",
                                         subCampaignId,
                                         platform,
                                         resend = false,
                                         ouCode = "",
                                         is_google_form = false,
                                         is_pay_get_coupon = false,
                                         qrscanlog_id = "",
                                         lineUserID = "",
                                         merchant_reference = "",
                                         engage_get_credit_session = "",
                                         profileName = "",
                                         channelSessionId = ""
}: IPhoneRegistration) => {
  return httpClient.post(
    apiUrl.REGISTRATION,
    {
      prefix: prefix,
      phone_number: phoneNumber,
      subcampaign_id: subCampaignId,
      platform: platform,
      resend: resend,
      ou_code: ouCode,
      is_google_form: is_google_form,
      is_pay_get_coupon: is_pay_get_coupon,
      qrscanlog_id: qrscanlog_id,
      line_user_id: lineUserID,
      merchant_reference: merchant_reference,
      engage_get_credit_session: engage_get_credit_session,
      line_profile_name: profileName,
      channel_session_id: channelSessionId
    }
  ).then((res) => res.data);
};

export const getVerifyRegistration = async ({ data }: { data: string }) => {
  return httpClient.get(
    apiUrl.VERIFY_REGISTRATION + data,
  ).then((res) => res.data);
};

export const getSeInvitationURL = async ({ id }: { id: string }) =>{
  return httpClient.get(
    apiUrl.GET_URL + id
  ).then((res) => res.data);
};

export const getLineAccessToken = async (code: string, defaultLogin: string) => {
  return httpClient.get(
    apiUrl.GET_LINE_ACCESS_TOKEN,
    { params: {
        code: code,
        default_login: defaultLogin
      }
    }
  ).then((res) => res.data);
};
